import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Check, Crown } from "@phosphor-icons/react";

export default function ShopSubscription() {
  const [plans, setPlans] = useState([]);
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/subscription-plans").then((r) => setPlans(r.data));
    api.get("/dashboard/shopkeeper").then((r) => setData(r.data));
  }, []);

  if (!data) return <div className="p-6">Loading…</div>;
  const current = data.subscription.plan;

  return (
    <div className="p-4 sm:p-6 lg:p-8 space-y-6">
      <div>
        <h1 className="font-heading text-2xl sm:text-3xl font-black tracking-tight">Subscription</h1>
        <p className="text-gray-600 text-sm">Your current plan: <b className="capitalize">{current}</b></p>
      </div>

      <div className="qd-card p-5 bg-[#F8CB46]/10 border-[#F8CB46]/50 flex items-center gap-4 flex-wrap">
        <Crown weight="fill" size={32} className="text-[#15803D]" />
        <div className="flex-1 min-w-[200px]">
          <div className="font-heading font-black text-xl capitalize">{current} plan active</div>
          <div className="text-sm text-gray-600">
            Products used: <b>{data.subscription.products_used}</b> of {data.subscription.product_limit === -1 ? "∞" : data.subscription.product_limit}
          </div>
          <div className="text-xs text-gray-500 mt-1">Status: <span className="text-green-600 font-semibold capitalize">{data.subscription.status}</span></div>
        </div>
        <div className="text-xs text-gray-500">
          To upgrade or change plan, contact the platform admin.
        </div>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {plans.map((p) => {
          const isCurrent = p.code === current;
          return (
            <div key={p.id} className={`qd-card p-5 ${isCurrent ? "ring-2 ring-[#F8CB46]" : ""}`} data-testid={`plan-${p.code}`}>
              <div className="text-xs uppercase tracking-widest font-bold text-gray-500">{p.name}</div>
              <div className="mt-2 flex items-baseline gap-1">
                <span className="font-heading text-3xl font-black">₹{p.price_monthly}</span>
                <span className="text-sm text-gray-500">/mo</span>
              </div>
              <ul className="mt-4 space-y-2 text-sm">
                {p.features.map((f, i) => (
                  <li key={i} className="flex items-start gap-2">
                    <Check size={16} weight="bold" className="text-[#15803D] mt-0.5 flex-shrink-0" />
                    {f}
                  </li>
                ))}
              </ul>
              {isCurrent && <div className="mt-4 text-center text-xs font-bold uppercase tracking-widest text-[#15803D]">Current plan</div>}
            </div>
          );
        })}
      </div>
    </div>
  );
}
